// @flow
import moment from 'moment';
import React, {Fragment} from 'react';
import {MdClose, MdEvent} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import styles from './changeRequestCard.css';
import Button from '../../Button';
import StudentSchedulingPopup from '../../StudentSchedulingPopup';
import Popup from '../../Popup';
type StopCardPropTypes = {
  changeRequest: Object,
  openScheduleAction: Function,
  rejectAction: Function,
  approveAction: Function,
  studentId: number,
};

const ChangeRequestCard = ({ changeRequest, rejectAction, approveAction }: StopCardPropTypes) => (
  <div className={styles.changeRequest}>
    <div className={styles.textContainer}>
      <p className={styles.title}>{changeRequest.toGatewayObj.name} <span className={styles.circle}></span></p>
      <p className={styles.subtitle}>{changeRequest.toGatewayObj.type}</p>
      <p className={styles.date}>Solicitado para el: <span className={styles.dateBold}>{moment(changeRequest.requested_at).format('LL')}</span></p>
    </div>
    <div className={styles.actions}>
      <Button
        Icon={MdClose}
        className={styles.actionButton}
        onClick={() => rejectAction()}
        title={i18n.t('buttons.reject')}
        size="small"
        tint="mediumGray"
      />
      <Button
        Icon={MdClose}
        className={styles.actionButton}
        onClick={() => approveAction()}
        title={i18n.t('buttons.aprove')}
        size="small"
      />
    </div>
  </div>
);

export default ChangeRequestCard;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentCard/ChangeRequestCard/index.jsx